import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { formsApi } from '../api/formsApi';

export function useFormStats() {
  return useQuery({
    queryKey: keys.formsStats,
    queryFn: ({ signal }) => formsApi.getStats({ signal }),
    staleTime: 60_000,
  });
}
